import { render, staticRenderFns } from "./SelectBookYear.vue?vue&type=template&id=7d6fc4b8"
import script from "./SelectBookYear.vue?vue&type=script&lang=ts"
export * from "./SelectBookYear.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports